const hasWindow = typeof window !== 'undefined';

const secureStore = hasWindow ? window.sessionStorage : null;
const legacyStore = hasWindow ? window.localStorage : null;

export const secureStorage = {
  getItem(key: string): string | null {
    const value = secureStore?.getItem(key);
    if (value !== null && value !== undefined) {
      return value;
    }
    const legacyValue = legacyStore?.getItem(key) ?? null;
    if (legacyValue !== null) {
      secureStore?.setItem(key, legacyValue);
      legacyStore?.removeItem(key);
    }
    return legacyValue;
  },

  setItem(key: string, value: string): void {
    secureStore?.setItem(key, value);
  },

  removeItem(key: string): void {
    secureStore?.removeItem(key);
    legacyStore?.removeItem(key);
  },
};
